import { useState, useEffect, useMemo } from 'react';
import { Link } from "react-router-dom";
import Sidebar from '../Sidebar'
import Header from '../Header'
import HeaderFilters from '../HeaderFilters';

import { GiPoliceOfficerHead } from "react-icons/gi";
import { MdCheck, MdLock, MdWhatsapp  } from "react-icons/md";

import { API_BASE } from '../../config/api';

import ReactApexChart from 'react-apexcharts';

function SesionesSuperLider() {

// Comparativo


const getCompareFilters = async ({
    nextRegionId = "",
    nextDistyId = "",
} = {}) => {
    try {
        const params = new URLSearchParams();

        if (nextRegionId) params.append("regionId", nextRegionId);
        if (nextDistyId) params.append("distyId", nextDistyId);

        const response = await fetch(
            `${API_BASE}/api/admin/dashboard/filters?${params.toString()}`,
            {
                method: "GET",
                credentials: "include",
            }
        );

        const result = await response.json();

        if (!response.ok || !result.success) {
            throw new Error(result.message || "Error al obtener filtros de comparación.");
        }

        setCompareDistys(result.data?.distys || []);
        setCompareGrados(result.data?.grados || []);

        return result.data;
    } catch (error) {
        console.error("Error filtros comparativo:", error);
        setError(error.message);
        return null;
    }
};

const handleToggleCompare = async () => {
    const nextMode = !compareMode;

    if (!nextMode) {
        setCompareMode(false);
        setCompareReady(false);

        setLeftData(null);
        setRightData(null);

        setLeftDistys([]);
        setLeftGrados([]);
        setRightDistys([]);
        setRightGrados([]);

        return;
    }

    try {
        setCompareReady(false);

        const nextLeft = {
            regionId,
            distyId,
            gradoId,
            startDate,
            endDate,
        };

        const nextRight = {
            regionId,
            distyId: "",
            gradoId: "",
            startDate,
            endDate,
        };

        setLeftFilters(nextLeft);
        setRightFilters(nextRight);

        setLeftData(null);
        setRightData(null);

        const [leftCatalogs, rightCatalogs] = await Promise.all([
            fetchDashboardFilters({
                regionId: nextLeft.regionId,
                distyId: nextLeft.distyId,
            }),
            fetchDashboardFilters({
                regionId: nextRight.regionId,
                distyId: nextRight.distyId,
            }),
        ]);

        setLeftDistys(leftCatalogs?.distys || []);
        setLeftGrados(leftCatalogs?.grados || []);

        setRightDistys(rightCatalogs?.distys || []);
        setRightGrados(rightCatalogs?.grados || []);

        setCompareMode(true);
        setCompareReady(true);
    } catch (error) {
        console.error("Error al activar comparativo:", error);
        setError(error.message);
        setCompareMode(false);
        setCompareReady(false);
    }
};

const handleLeftRegionChange = async (value) => {
    const nextFilters = {
        ...leftFilters,
        regionId: value,
        distyId: "",
        gradoId: "",
    };

    setLeftFilters(nextFilters);

    const catalogs = await fetchDashboardFilters({
        regionId: value,
        distyId: "",
    });

    setLeftDistys(catalogs.distys || []);
    setLeftGrados(catalogs.grados || []);
};

const handleLeftDistyChange = async (value) => {
    const nextFilters = {
        ...leftFilters,
        distyId: value,
        gradoId: "",
    };

    setLeftFilters(nextFilters);

    const catalogs = await fetchDashboardFilters({
        regionId: nextFilters.regionId,
        distyId: value,
    });

    setLeftGrados(catalogs.grados || []);
};

const handleLeftGradoChange = (value) => {
    setLeftFilters((prev) => ({
        ...prev,
        gradoId: value,
    }));
};

const handleRightRegionChange = async (value) => {
    const nextFilters = {
        ...rightFilters,
        regionId: value,
        distyId: "",
        gradoId: "",
    };

    setRightFilters(nextFilters);

    const catalogs = await fetchDashboardFilters({
        regionId: value,
        distyId: "",
    });

    setRightDistys(catalogs.distys || []);
    setRightGrados(catalogs.grados || []);
};

const handleRightDistyChange = async (value) => {
    const nextFilters = {
        ...rightFilters,
        distyId: value,
        gradoId: "",
    };

    setRightFilters(nextFilters);

    const catalogs = await fetchDashboardFilters({
        regionId: nextFilters.regionId,
        distyId: value,
    });

    setRightGrados(catalogs.grados || []);
};

const handleRightGradoChange = (value) => {
    setRightFilters((prev) => ({
        ...prev,
        gradoId: value,
    }));
};

const [admin, setAdmin] = useState(null);
const [loadingAdmin, setLoadingAdmin] = useState(true);

useEffect(() => {
const fetchAdmin = async () => {
    try {
        setLoadingAdmin(true);

        const res = await fetch(`${API_BASE}/api/admin/me`, {
            method: "GET",
            credentials: "include",
        });

        const data = await res.json();

        if (!res.ok || !data.ok) {
            throw new Error(data.message || "No se pudo obtener la información del admin");
        }

        setAdmin(data.data);
    } catch (error) {
        console.error("Error al obtener admin:", error);
        setAdmin(null);
    } finally {
        setLoadingAdmin(false);
    }
};

fetchAdmin();
}, []);

const SESSION_MIN_DATE = "2026-05-11";

const formatDateInput = (date) => {
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const dd = String(date.getDate()).padStart(2, "0");

    return `${yyyy}-${mm}-${dd}`;
};

const parseDateInput = (dateString) => {
    const [year, month, day] = dateString.split("-").map(Number);
    return new Date(year, month - 1, day);
};

const clampSessionDate = (dateString) => {
    if (!dateString) return SESSION_MIN_DATE;

    const selectedDate = parseDateInput(dateString);
    const minDate = parseDateInput(SESSION_MIN_DATE);

    if (selectedDate < minDate) {
        return SESSION_MIN_DATE;
    }

    return dateString;
};

const getLast15DaysSessionRange = () => {
    const today = new Date();
    const start = new Date(today);

    // Incluye hoy + 14 días anteriores
    start.setDate(today.getDate() - 14);

    const minDate = parseDateInput(SESSION_MIN_DATE);

    const safeStart = start < minDate ? minDate : start;
    const safeEnd = today < minDate ? minDate : today;

    return {
        startDate: formatDateInput(safeStart),
        endDate: formatDateInput(safeEnd),
    };
};

// Panel General
    const defaultSessionDates = getLast15DaysSessionRange();

    const [compareApplied, setCompareApplied] = useState(false);

const [compareRegionId, setCompareRegionId] = useState("");
const [compareDistyId, setCompareDistyId] = useState("");
const [compareGradoId, setCompareGradoId] = useState("");

const [compareDistys, setCompareDistys] = useState([]);
const [compareGrados, setCompareGrados] = useState([]);
const [compareMode, setCompareMode] = useState(false);
const [compareReady, setCompareReady] = useState(false);

const [leftFilters, setLeftFilters] = useState({
    regionId: "",
    distyId: "",
    gradoId: "",
    startDate: defaultSessionDates.startDate,
    endDate: defaultSessionDates.endDate,
});

const [rightFilters, setRightFilters] = useState({
    regionId: "",
    distyId: "",
    gradoId: "",
    startDate: defaultSessionDates.startDate,
    endDate: defaultSessionDates.endDate,
});

const [leftDistys, setLeftDistys] = useState([]);
const [leftGrados, setLeftGrados] = useState([]);

const [rightDistys, setRightDistys] = useState([]);
const [rightGrados, setRightGrados] = useState([]);

const [leftData, setLeftData] = useState(null);
const [rightData, setRightData] = useState(null);

const [loadingLeftCompare, setLoadingLeftCompare] = useState(false);
const [loadingRightCompare, setLoadingRightCompare] = useState(false);

    const [regions, setRegions] = useState([]);
    const [regionId, setRegionId] = useState("");

    const [distys, setDistys] = useState([]);
    const [grados, setGrados] = useState([]);

    const [distyId, setDistyId] = useState("");
    const [gradoId, setGradoId] = useState("");

    const [startDate, setStartDate] = useState(defaultSessionDates.startDate);
    const [endDate, setEndDate] = useState(defaultSessionDates.endDate);

    const [filtersReady, setFiltersReady] = useState(false);
    

    const [downloadingExcel, setDownloadingExcel] = useState(false);

    const [summary, setSummary] = useState({
        usuariosRegistrados: 0,
        usuariosActivos: 0,
        usuariosNoActivos: 0,
        usuariosBorrados: 0,
        usuariosMexico: 0,
        usuariosLatam: 0,
        usuariosParticipantes: 0,
        usuariosNoParticipantes: 0,
    });

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const handleStartDateChange = (value) => {
        const safeStartDate = clampSessionDate(value);

        setStartDate(safeStartDate);

        if (endDate && parseDateInput(endDate) < parseDateInput(safeStartDate)) {
            setEndDate(safeStartDate);
        }
    };

    const handleEndDateChange = (value) => {
        const safeEndDate = clampSessionDate(value);

        setEndDate(safeEndDate);

        if (startDate && parseDateInput(startDate) > parseDateInput(safeEndDate)) {
            setStartDate(safeEndDate);
        }
};

const handleRegionChange = async (value) => {
    setRegionId(value);
    setDistyId("");
    setGradoId("");

    await getFilters({
        nextRegionId: value,
        nextDistyId: "",
    });
};

const handleDistyChange = async (value) => {
    setDistyId(value);
    setGradoId("");

    await getFilters({
        nextRegionId: regionId,
        nextDistyId: value,
        updateRegions: false,
        updateDistys: false,
        updateGrados: true,
    });
};;

const handleGradoChange = (value) => {
    setGradoId(value);
};

    // =============================
    // Cargar filtros iniciales
    // =============================

const getFilters = async ({
    nextRegionId = "",
    nextDistyId = "",
    updateRegions = true,
    updateDistys = true,
    updateGrados = true,
} = {}) => {
    try {
        const params = new URLSearchParams();

        if (nextRegionId) params.append("regionId", nextRegionId);
        if (nextDistyId) params.append("distyId", nextDistyId);

        const response = await fetch(
            `${API_BASE}/api/admin/dashboard/filters?${params.toString()}`,
            {
                method: "GET",
                credentials: "include",
            }
        );

        const result = await response.json();

        if (!response.ok || !result.success) {
            throw new Error(result.message || "Error al obtener filtros.");
        }

        if (updateRegions) {
            setRegions(result.data?.regions || []);
        }

        if (updateDistys) {
            setDistys(result.data?.distys || []);
        }

        if (updateGrados) {
            setGrados(result.data?.grados || []);
        }

        return result.data;
    } catch (error) {
        console.error("Error filtros HomeSuperLider:", error);
        setError(error.message);
        return null;
    }
};

useEffect(() => {
    const initFilters = async () => {
        try {
            const data = await getFilters({
                updateRegions: true,
                updateDistys: true,
                updateGrados: true,
            });

            const defaultRegionId = String(data?.defaultRegionId || "");

            setRegionId(defaultRegionId);
            setDistyId("");
            setGradoId("");

            setStartDate(defaultSessionDates.startDate);
            setEndDate(defaultSessionDates.endDate);

            if (defaultRegionId) {
                await getFilters({
                    nextRegionId: defaultRegionId,
                    nextDistyId: "",
                    updateRegions: false,
                    updateDistys: true,
                    updateGrados: true,
                });
            }
        } catch (error) {
            console.error("Error al inicializar filtros:", error);
        } finally {
            setFiltersReady(true);
        }
    };

    initFilters();
}, []);

// Panel Sesiones
const [datosSesiones, setDatosSesiones] = useState({
    sesionesGenerales: {
        sesionesIniciadas: 0,
        sesionesTerminadas: 0,
        sesionesIncompletas: 0,
        tasaTerminadas: 0,
        tasaIncompletas: 0,
    },
    sesionesTendenciaCards: {
        categories: [],
        iniciadas: [],
        terminadas: [],
        incompletas: [],
    },
    topSesiones: [],
    sesionesEspeciales: {
        usuariosBase: 0,
        usuariosParticipantesEspecial: 0,
        usuariosNoParticipantesEspecial: 0,
        tasaParticipacion: 0,
    },
    sesionesEspecialesTendenciaCards: {
        categories: [],
        participantesEnVivo: [],
        grabaciones: [],
    },
    topSesionesEspeciales: {
        disponible: false,
        message: "",
        top: [],
    },
    panduitUniversity: {
        disponible: false,
        message: "",
        usuariosParticipantes: 0,
        cursosTerminados: 0,
        cursosCompletados: 0,
        topCursos: [],
    },
    comparativo: null,
});

const [loadingSesiones, setLoadingSesiones] = useState(false);

// =============================
// Obtener sesiones - Super Líder
// =============================
const fetchSesionesByFilters = async ({
    regionId = "",
    distyId = "",
    gradoId = "",
    startDate = "",
    endDate = "",
}) => {
    const params = new URLSearchParams();

    if (regionId) params.append("regionId", regionId);
    if (distyId) params.append("distyId", distyId);
    if (gradoId) params.append("gradoId", gradoId);
    if (startDate) params.append("startDate", startDate);
    if (endDate) params.append("endDate", endDate);

    const response = await fetch(
        `${API_BASE}/api/admin/dashboard/superlider-sesiones?${params.toString()}`,
        {
            method: "GET",
            credentials: "include",
        }
    );

    const result = await response.json();

    if (!response.ok || !result.ok) {
        throw new Error(result.message || "Error al obtener sesiones.");
    }

    return result.data;
};

const fetchDashboardFilters = async ({ regionId = "", distyId = "" } = {}) => {
    const params = new URLSearchParams();

    if (regionId) params.append("regionId", regionId);
    if (distyId) params.append("distyId", distyId);

    const response = await fetch(
        `${API_BASE}/api/admin/dashboard/filters?${params.toString()}`,
        {
            method: "GET",
            credentials: "include",
        }
    );

    const result = await response.json();

    if (!response.ok || !result.success) {
        throw new Error(result.message || "Error al obtener filtros.");
    }

    return result.data;
};


const getSesionesSuperLider = async () => {
    try {
        setLoadingSesiones(true);
        setError("");

        const params = new URLSearchParams();

        if (regionId) params.append("regionId", regionId);
        if (distyId) params.append("distyId", distyId);
        if (gradoId) params.append("gradoId", gradoId);
        if (startDate) params.append("startDate", startDate);
        if (endDate) params.append("endDate", endDate);

        const response = await fetch(
            `${API_BASE}/api/admin/dashboard/superlider-sesiones?${params.toString()}`,
            {
                method: "GET",
                credentials: "include",
            }
        );

        const result = await response.json();

        if (!response.ok || !result.ok) {
            throw new Error(result.message || "Error al obtener sesiones.");
        }

        setDatosSesiones({
            sesionesGenerales: result.data?.sesionesGenerales || {
                sesionesIniciadas: 0,
                sesionesTerminadas: 0,
                sesionesIncompletas: 0,
                tasaTerminadas: 0,
                tasaIncompletas: 0,
            },
            sesionesTendenciaCards: result.data?.sesionesTendenciaCards || {
                categories: [],
                iniciadas: [],
                terminadas: [],
                incompletas: [],
            },
            topSesiones: result.data?.topSesiones || [],
            sesionesEspeciales: result.data?.sesionesEspeciales || {
                usuariosBase: 0,
                usuariosParticipantesEspecial: 0,
                usuariosNoParticipantesEspecial: 0,
                tasaParticipacion: 0,
            },
            sesionesEspecialesTendenciaCards: result.data?.sesionesEspecialesTendenciaCards || {
                categories: [],
                participantesEnVivo: [],
                grabaciones: [],
            },

            topSesionesEspeciales: result.data?.topSesionesEspeciales || {
                disponible: false,
                message: "",
                top: [],
            },

            panduitUniversity: result.data?.panduitUniversity || {
                disponible: false,
                message: "",
                usuariosParticipantes: 0,
                cursosTerminados: 0,
                cursosCompletados: 0,
                topCursos: [],
            },

            comparativo: result.data?.comparativo || null,
        });
    } catch (error) {
        console.error("Error sesiones Super Líder:", error);
        setError(error.message);
    } finally {
        setLoadingSesiones(false);
    }
};

useEffect(() => {
    if (!filtersReady) return;
    if (compareMode) return;

    getSesionesSuperLider();
}, [
    filtersReady,
    compareMode,
    regionId,
    distyId,
    gradoId,
    startDate,
    endDate,
]);

useEffect(() => {
    if (!compareMode) return;

    setLeftFilters((prev) => {
        if (prev.startDate === startDate && prev.endDate === endDate) {
            return prev;
        }

        return {
            ...prev,
            startDate,
            endDate,
        };
    });

    setRightFilters((prev) => {
        if (prev.startDate === startDate && prev.endDate === endDate) {
            return prev;
        }

        return {
            ...prev,
            startDate,
            endDate,
        };
    });
}, [
    compareMode,
    startDate,
    endDate,
]);

useEffect(() => {
    if (!compareMode || !compareReady) return;

    const timeoutId = setTimeout(async () => {
        try {
            setLoadingLeftCompare(true);
            setLoadingRightCompare(true);
            setError("");

            const [leftResult, rightResult] = await Promise.all([
                fetchSesionesByFilters(leftFilters),
                fetchSesionesByFilters(rightFilters),
            ]);

            setLeftData(leftResult);
            setRightData(rightResult);
        } catch (error) {
            console.error("Error al cargar comparativos:", error);
            setError(error.message);
        } finally {
            setLoadingLeftCompare(false);
            setLoadingRightCompare(false);
        }
    }, 250);

    return () => {
        clearTimeout(timeoutId);
    };
}, [
    compareMode,
    compareReady,

    leftFilters.regionId,
    leftFilters.distyId,
    leftFilters.gradoId,
    leftFilters.startDate,
    leftFilters.endDate,

    rightFilters.regionId,
    rightFilters.distyId,
    rightFilters.gradoId,
    rightFilters.startDate,
    rightFilters.endDate,
]);



const miniChartBaseOptions = useMemo(() => ({
    chart: {
        type: "area",
        sparkline: {
            enabled: true,
        },
        toolbar: {
            show: false,
        },
        zoom: {
            enabled: false,
        },
    },
    stroke: {
        curve: "smooth",
        width: 3,
    },
    fill: {
        opacity: 0.12,
    },
    dataLabels: {
        enabled: false,
    },
    tooltip: {
        enabled: true,
        x: {
            show: true,
        },
    },
    grid: {
        show: false,
    },
    xaxis: {
        categories: datosSesiones.sesionesTendenciaCards.categories,
        labels: {
            show: false,
        },
        axisBorder: {
            show: false,
        },
        axisTicks: {
            show: false,
        },
    },
    yaxis: {
        show: false,
    },
}), [datosSesiones.sesionesTendenciaCards.categories]);

const sesionesIniciadasSeries = useMemo(() => [
    {
        name: "Sesiones iniciadas",
        data: datosSesiones.sesionesTendenciaCards.iniciadas,
    },
], [datosSesiones.sesionesTendenciaCards.iniciadas]);

const sesionesTerminadasSeries = useMemo(() => [
    {
        name: "Sesiones terminadas",
        data: datosSesiones.sesionesTendenciaCards.terminadas,
    },
], [datosSesiones.sesionesTendenciaCards.terminadas]);

const sesionesIncompletasSeries = useMemo(() => [
    {
        name: "Sesiones incompletas",
        data: datosSesiones.sesionesTendenciaCards.incompletas,
    },
], [datosSesiones.sesionesTendenciaCards.incompletas]);

const buildMiniChartOptions = (color) => ({
    chart: {
        type: "area",
        sparkline: {
            enabled: true,
        },
        toolbar: {
            show: false,
        },
        zoom: {
            enabled: false,
        },
    },
    colors: [color],
    stroke: {
        curve: "smooth",
        width: 3,
        colors: [color],
    },
    fill: {
        type: "solid",
        opacity: 0.12,
        colors: [color],
    },
    dataLabels: {
        enabled: false,
    },
    tooltip: {
        enabled: true,
    },
    grid: {
        show: false,
    },
    xaxis: {
        categories: datosSesiones.sesionesTendenciaCards.categories,
        labels: {
            show: false,
        },
        axisBorder: {
            show: false,
        },
        axisTicks: {
            show: false,
        },
    },
    yaxis: {
        show: false,
    },
});

const sesionesIniciadasOptions = useMemo(
    () => buildMiniChartOptions("#3155D4"),
    [datosSesiones.sesionesTendenciaCards.categories]
);

const sesionesTerminadasOptions = useMemo(
    () => buildMiniChartOptions("#07750b"),
    [datosSesiones.sesionesTendenciaCards.categories]
);

const sesionesIncompletasOptions = useMemo(
    () => buildMiniChartOptions("#b91d12"),
    [datosSesiones.sesionesTendenciaCards.categories]
);

const buildCompareMiniChartOptions = (color, categories = []) => ({
    chart: {
        type: "area",
        sparkline: {
            enabled: true,
        },
        toolbar: {
            show: false,
        },
        zoom: {
            enabled: false,
        },
    },
    colors: [color],
    stroke: {
        curve: "smooth",
        width: 3,
        colors: [color],
    },
    fill: {
        type: "solid",
        opacity: 0.14,
        colors: [color],
    },
    dataLabels: {
        enabled: false,
    },
    tooltip: {
        enabled: true,
    },
    grid: {
        show: false,
    },
    xaxis: {
        categories,
        labels: {
            show: false,
        },
        axisBorder: {
            show: false,
        },
        axisTicks: {
            show: false,
        },
    },
    yaxis: {
        show: false,
    },
});

const CompareSesionesPanel = ({
    title,
    filters,
    regions,
    distys,
    grados,
    data,
    loading,
    onRegionChange,
    onDistyChange,
    onGradoChange,
}) => {
    const metricas = data?.sesionesGenerales || {
        sesionesIniciadas: 0,
        sesionesTerminadas: 0,
        sesionesIncompletas: 0,
        tasaTerminadas: 0,
        tasaIncompletas: 0,
    };

    const tendencia = data?.sesionesTendenciaCards || {
        categories: [],
        iniciadas: [],
        terminadas: [],
        incompletas: [],
    };

    const iniciadasOptions = useMemo(
        () => buildCompareMiniChartOptions("#3155D4", tendencia.categories || []),
        [tendencia.categories]
    );

    const terminadasOptions = useMemo(
        () => buildCompareMiniChartOptions("#07750b", tendencia.categories || []),
        [tendencia.categories]
    );

    const incompletasOptions = useMemo(
        () => buildCompareMiniChartOptions("#b91d12", tendencia.categories || []),
        [tendencia.categories]
    );

    const iniciadasSeries = [
        {
            name: "Sesiones iniciadas",
            data: tendencia.iniciadas || [],
        },
    ];

    const terminadasSeries = [
        {
            name: "Sesiones terminadas",
            data: tendencia.terminadas || [],
        },
    ];

    const incompletasSeries = [
        {
            name: "Sesiones incompletas",
            data: tendencia.incompletas || [],
        },
    ];

    return (
        <div className="card h-100">
            <div className="card-header">
                <h4 className="card-title mb-0">{title}</h4>
            </div>

            <div className="card-body">
                <div className="row g-3 mb-4">
                    <div className="col-md-4">
                        <label className="form-label">Región</label>
                        <select
                            className="form-select"
                            value={filters.regionId}
                            onChange={(e) => onRegionChange(e.target.value)}
                        >
                            <option value="">Todas</option>
                            {regions.map((region) => (
                                <option key={region.Region_ID} value={region.Region_ID}>
                                    {region.Region_Nombre}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className="col-md-4">
                        <label className="form-label">Distribuidor</label>
                        <select
                            className="form-select"
                            value={filters.distyId}
                            onChange={(e) => onDistyChange(e.target.value)}
                        >
                            <option value="">Todos</option>
                            {distys.map((disty) => (
                                <option key={disty.Disty_ID} value={disty.Disty_ID}>
                                    {disty.Disty_Nombre}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className="col-md-4">
                        <label className="form-label">Grado</label>
                        <select
                            className="form-select"
                            value={filters.gradoId}
                            onChange={(e) => onGradoChange(e.target.value)}
                        >
                            <option value="">Todos</option>
                            {grados.map((grado) => (
                                <option key={grado.Grado_ID} value={grado.Grado_ID}>
                                    {grado.Grado_Nombre}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>

                <div className="row">
                    <div className="col-12">
                        <div className="card mb-3">
                            <div className="card-body pb-0">
                                <div className="d-flex justify-content-between">
                                    <div>
                                        <span>Sesiones iniciadas</span>
                                        <h2 className="counter mt-2">
                                            {loading
                                                ? "..."
                                                : Number(metricas.sesionesIniciadas || 0).toLocaleString("es-MX")}
                                        </h2>
                                    </div>

                                    <div className="bg-primary-subtle rounded p-3 h-100">
                                        <i className="feather-play text-primary"></i>
                                    </div>
                                </div>
                            </div>

                            <ReactApexChart
                                options={iniciadasOptions}
                                series={iniciadasSeries}
                                type="area"
                                height={90}
                            />
                        </div>
                    </div>

                    <div className="col-md-6">
                        <div className="card mb-3">
                            <div className="card-body pb-0">
                                <span>Sesiones terminadas</span>

                                <h3 className="counter mt-2">
                                    {loading
                                        ? "..."
                                        : Number(metricas.sesionesTerminadas || 0).toLocaleString("es-MX")}
                                </h3>

                                <small className="text-success">
                                    {loading
                                        ? "..."
                                        : `${Number(metricas.tasaTerminadas || 0)}% terminadas`}
                                </small>
                            </div>

                            <ReactApexChart
                                options={terminadasOptions}
                                series={terminadasSeries}
                                type="area"
                                height={80}
                            />
                        </div>
                    </div>

                    <div className="col-md-6">
                        <div className="card mb-3">
                            <div className="card-body pb-0">
                                <span>Sesiones incompletas</span>

                                <h3 className="counter mt-2">
                                    {loading
                                        ? "..."
                                        : Number(metricas.sesionesIncompletas || 0).toLocaleString("es-MX")}
                                </h3>

                                <small className="text-danger">
                                    {loading
                                        ? "..."
                                        : `${Number(metricas.tasaIncompletas || 0)}% incompletas`}
                                </small>
                            </div>

                            <ReactApexChart
                                options={incompletasOptions}
                                series={incompletasSeries}
                                type="area"
                                height={80}
                            />
                        </div>
                    </div>
                </div>

                <div className="card mb-0">
                    <div className="card-header">
                        <h5 className="mb-0">Top 5 sesiones</h5>
                    </div>

                    <div className="card-body">
                        {loading ? (
                            <p className="mb-0">Cargando sesiones...</p>
                        ) : !data?.topSesiones?.length ? (
                            <p className="text-muted mb-0">
                                No hay sesiones disponibles.
                            </p>
                        ) : (
                            <div className="table-responsive">
                                <table className="table table-sm align-middle mb-0">
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>Sesión</th>
                                            <th className="text-end">Vistas</th>
                                            <th className="text-end">Terminadas</th>
                                            <th className="text-end">Incompletas</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {data.topSesiones.map((sesion, index) => (
                                            <tr key={sesion.rutaDetId}>
                                                <td>{index + 1}</td>
                                                <td>{sesion.videoTitulo}</td>
                                                <td className="text-end">
                                                    {Number(sesion.totalRepeticiones || 0).toLocaleString("es-MX")}
                                                </td>
                                                <td className="text-end">
                                                    {Number(sesion.totalTerminadas || 0).toLocaleString("es-MX")}
                                                </td>
                                                <td className="text-end">
                                                    {Number(sesion.totalIncompletas || 0).toLocaleString("es-MX")}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

const buildEspecialMiniChartOptions = (color) => ({
    chart: {
        type: "area",
        sparkline: {
            enabled: true,
        },
        toolbar: {
            show: false,
        },
        zoom: {
            enabled: false,
        },
    },
    colors: [color],
    stroke: {
        curve: "smooth",
        width: 3,
        colors: [color],
    },
    fill: {
        type: "solid",
        opacity: 0.16,
        colors: [color],
    },
    dataLabels: {
        enabled: false,
    },
    tooltip: {
        enabled: true,
    },
    grid: {
        show: false,
    },
    xaxis: {
        categories: datosSesiones.sesionesEspecialesTendenciaCards.categories,
        labels: {
            show: false,
        },
        axisBorder: {
            show: false,
        },
        axisTicks: {
            show: false,
        },
    },
    yaxis: {
        show: false,
    },
});

const especialEnVivoOptions = useMemo(
    () => buildEspecialMiniChartOptions("#3155D4"),
    [datosSesiones.sesionesEspecialesTendenciaCards.categories]
);

const especialGrabacionOptions = useMemo(
    () => buildEspecialMiniChartOptions("#C82424"),
    [datosSesiones.sesionesEspecialesTendenciaCards.categories]
);

const especialEnVivoSeries = useMemo(() => [
    {
        name: "Participantes en vivo",
        data: datosSesiones.sesionesEspecialesTendenciaCards.participantesEnVivo,
    },
], [datosSesiones.sesionesEspecialesTendenciaCards.participantesEnVivo]);

const especialGrabacionSeries = useMemo(() => [
    {
        name: "Grabaciones",
        data: datosSesiones.sesionesEspecialesTendenciaCards.grabaciones,
    },
], [datosSesiones.sesionesEspecialesTendenciaCards.grabaciones]);

const panduitUniversityChartSeries = useMemo(() => ([
    Number(datosSesiones.panduitUniversity?.usuariosParticipantes || 0),
    0,
    0,
    Number(datosSesiones.panduitUniversity?.cursosCompletados || 0),
]), [
    datosSesiones.panduitUniversity?.usuariosParticipantes,
    datosSesiones.panduitUniversity?.cursosCompletados,
]);

const panduitUniversityChartOptions = useMemo(() => ({
    chart: {
        height: 390,
        type: "radialBar",
    },

    stroke: {
        lineCap: "butt", // <-- Esto quita las puntas redondeadas
    },

    plotOptions: {
        radialBar: {
            offsetY: 0,
            startAngle: 0,
            endAngle: 270,

            hollow: {
                margin: 5,
                size: "30%",
                background: "transparent",
                image: undefined,
            },

            track: {
                background: "#f2f2f2",
                strokeWidth: "100%",
                margin: 7,
            },

            dataLabels: {
                name: {
                    show: false,
                },
                value: {
                    show: false,
                },
            },

            barLabels: {
                enabled: true,
                useSeriesColors: true,
                offsetX: -8,
                fontSize: "12px",
                formatter: function (seriesName, opts) {
                    return `${seriesName}: ${opts.w.globals.series[opts.seriesIndex]}`;
                },
            },
        },
    },

    colors: [
        "#1ab7ea",
        "#00d9d9",
        "#7DA1F7",
        "#0077B5",
    ],

    labels: [
        "Usuarios participantes",
        "Total Usuarios",
        "Usuarios en University of Panduit",
        "Completados U.P.",
    ],

    responsive: [
        {
            breakpoint: 480,
            options: {
                plotOptions: {
                    radialBar: {
                        barLabels: {
                            enabled: false,
                        },
                    },
                },
            },
        },
    ],
}), [panduitUniversityChartSeries]);




    return (
        <>
        <Sidebar/>
        <main class="main-content">
            <Header/>
            <div class="content-inner container-fluid pb-0" id="page_layout">
                
                <HeaderFilters
                    title="Datos Sesiones"
                    subtitle="Panel Super Líder"

                    regions={regions}
                    distys={distys}
                    grados={grados}

                    regionId={regionId}
                    distyId={distyId}
                    gradoId={gradoId}

                    startDate={startDate}
                    endDate={endDate}

                    onRegionChange={handleRegionChange}
                    onDistyChange={handleDistyChange}
                    onGradoChange={handleGradoChange}
                    onStartDateChange={handleStartDateChange}
                    onEndDateChange={handleEndDateChange}
                />

                <div className="d-flex justify-content-end mt-3 mb-3">
                    <button
                        type="button"
                        className={compareMode ? "btn btn-outline-danger" : "btn btn-primary"}
                        onClick={handleToggleCompare}
                    >
                        {compareMode ? "Cerrar comparación" : "Comparar"}
                    </button>
                </div>

                {!compareMode && (
                    <>
                        <div className="row">
                            <div className="col-lg-3">
                                <div className="card">
                                    <div className="card-body">
                                        <div className="d-flex justify-content-between">
                                            <div className="bg-primary-subtle rounded p-3">
                                                <svg fill="none" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M16.2966 15.5383C16.3775 17.3704 14.8989 18.9196 12.9944 18.9975C12.8541 19.0034 6.01507 18.9896 6.01507 18.9896C4.11972 19.1335 2.46091 17.7715 2.31141 15.9463C2.30014 15.8103 2.30322 8.47219 2.30322 8.47219C2.21925 6.63815 3.6958 5.08499 5.60139 5.00418C5.74372 4.99728 12.5735 5.01009 12.5735 5.01009C14.4781 4.86818 16.142 6.24001 16.2895 8.07405C16.2997 8.2061 16.2966 15.5383 16.2966 15.5383Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                    <path d="M16.2998 9.97984L19.5928 7.28484C20.4088 6.61684 21.6328 7.19884 21.6318 8.25184L21.6198 15.6008C21.6188 16.6538 20.3938 17.2308 19.5798 16.5628L16.2998 13.8678" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                </svg>
                                            </div>

                                            <div>
                                                <span>Sesiones iniciadas</span>
                                            </div>
                                        </div>

                                        <div className="text-center">
                                            <h2 className="counter">
                                                {loadingSesiones
                                                    ? "..."
                                                    : Number(datosSesiones.sesionesGenerales.sesionesIniciadas || 0).toLocaleString("es-MX")}
                                            </h2>

                                            <div>
                                                <span className="text-primary">
                                                    Total de sesiones vistas
                                                </span>
                                            </div>
                                        </div>
                                    </div>

                                    <div style={{ minHeight: "80px" }}>
                                        <ReactApexChart
                                            options={sesionesIniciadasOptions}
                                            series={sesionesIniciadasSeries}
                                            type="area"
                                            height={80}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-3">
                                <div className="card">
                                    <div className="card-body">
                                        <div className="d-flex justify-content-between">
                                            <div className="bg-success-subtle rounded p-3">
                                                <svg fill="none" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M16.3345 2.75024H7.66549C4.64449 2.75024 2.75049 4.88924 2.75049 7.91624V16.0842C2.75049 19.1112 4.63549 21.2502 7.66549 21.2502H16.3335C19.3645 21.2502 21.2505 19.1112 21.2505 16.0842V7.91624C21.2505 4.88924 19.3645 2.75024 16.3345 2.75024Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                    <path d="M8.43994 12.0002L10.8139 14.3732L15.5599 9.6272" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                </svg>
                                            </div>

                                            <div>
                                                <span>Sesiones terminadas</span>
                                            </div>
                                        </div>

                                        <div className="text-center">
                                            <h2 className="counter">
                                                {loadingSesiones
                                                    ? "..."
                                                    : Number(datosSesiones.sesionesGenerales.sesionesTerminadas || 0).toLocaleString("es-MX")}
                                            </h2>

                                            <div>
                                                <span className="text-success">
                                                    {loadingSesiones
                                                        ? "..."
                                                        : `${Number(datosSesiones.sesionesGenerales.tasaTerminadas || 0)}% terminadas`}
                                                </span>
                                            </div>
                                        </div>
                                    </div>

                                    <div style={{ minHeight: "80px" }}>
                                        <ReactApexChart
                                            options={sesionesTerminadasOptions}
                                            series={sesionesTerminadasSeries}
                                            type="area"
                                            height={80}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-3">
                                <div className="card">
                                    <div className="card-body">
                                        <div className="d-flex justify-content-between">
                                            <div className="rounded p-3 bg-danger-subtle">
                                                <svg fill="none" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                                                    <path d="M14.3955 9.59497L9.60352 14.387" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                    <path d="M14.3971 14.3898L9.60107 9.59277" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M16.3345 2.75024H7.66549C4.64449 2.75024 2.75049 4.88924 2.75049 7.91624V16.0842C2.75049 19.1112 4.63549 21.2502 7.66549 21.2502H16.3335C19.3645 21.2502 21.2505 19.1112 21.2505 16.0842V7.91624C21.2505 4.88924 19.3645 2.75024 16.3345 2.75024Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                </svg>
                                            </div>

                                            <div>
                                                <span>Sesiones incompletas</span>
                                            </div>
                                        </div>

                                        <div className="text-center">
                                            <h2 className="counter">
                                                {loadingSesiones
                                                    ? "..."
                                                    : Number(datosSesiones.sesionesGenerales.sesionesIncompletas || 0).toLocaleString("es-MX")}
                                            </h2>

                                            <div>
                                                <span className="text-danger">
                                                    {loadingSesiones
                                                        ? "..."
                                                        : `${Number(datosSesiones.sesionesGenerales.tasaIncompletas || 0)}% incompletas`}
                                                </span>
                                            </div>
                                        </div>
                                    </div>

                                    <div style={{ minHeight: "80px" }}>
                                        <ReactApexChart
                                            options={sesionesIncompletasOptions}
                                            series={sesionesIncompletasSeries}
                                            type="area"
                                            height={80}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-3">
                                <div className="card">
                                    <div className="card-header">
                                        <div className="header-title">
                                            <h4 className="card-title">Top 5 Sesiones</h4>
                                        </div>
                                    </div>

                                    <div className="card-body"
                                    style={{
                                            maxHeight: "210px",
                                            overflowY: "auto",
                                            overflowX: "hidden",
                                        }}>
                                        {loadingSesiones ? (
                                            <p className="mb-0">Cargando sesiones...</p>
                                        ) : datosSesiones.topSesiones.length === 0 ? (
                                            <p className="mb-0 text-muted">
                                                No hay sesiones para los filtros seleccionados.
                                            </p>
                                        ) : (
                                            <ul className="list-inline m-0 p-0">
                                                {datosSesiones.topSesiones.map((sesion, index) => (
                                                    <li
                                                        key={sesion.rutaDetId}
                                                        className="d-flex mb-4 align-items-center"
                                                    >
                                                        
                                                        <span className="fw-bold">
                                                            {index + 1}°
                                                        </span>

                                                        <div className="ms-3 flex-grow-1">
                                                            <h6 className="mb-1">
                                                                {sesion.videoTitulo}
                                                            </h6>

                                                            <small>
                                                                {Number(sesion.totalRepeticiones || 0).toLocaleString("es-MX")} vistas
                                                            </small>
                                                        </div>

                                                        {/* <div className="text-end">
                                                            <p className="mb-0">
                                                                {Number(sesion.totalRepeticiones || 0).toLocaleString("es-MX")} vistas
                                                            </p>

                                                            <small className="text-success d-block">
                                                                {Number(sesion.totalTerminadas || 0).toLocaleString("es-MX")} terminadas
                                                            </small>

                                                            <small className="text-danger d-block">
                                                                {Number(sesion.totalIncompletas || 0).toLocaleString("es-MX")} incompletas
                                                            </small> 
                                                        </div> */}
                                                    </li>
                                                ))}
                                            </ul>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <div className="row">
                            <div className="d-flex justify-content-between">
                                <h5>Sesiones Especiales</h5>
                                <h6>
                                    Fecha de actualización:{" "}
                                    {new Date().toLocaleDateString("es-MX")}
                                </h6>
                            </div>

                            <div className="col-sm-6 col-lg-6 col-xl-3">
                                <div className="card">
                                    <div className="card-body iq-box-relative">
                                        <div
                                            className="iq-service d-flex align-items-center justify-content-between"
                                            style={{ position: "relative" }}
                                        >
                                            <div className="service-data">
                                                <h3 className="counter">
                                                    {loadingSesiones
                                                        ? "..."
                                                        : `${Number(datosSesiones.sesionesEspeciales.tasaParticipacion || 0)}%`}
                                                </h3>

                                                <p className="mb-0">
                                                    Usuarios participantes en vivo
                                                </p>

                                                <small className="text-muted">
                                                    {loadingSesiones
                                                        ? "..."
                                                        : `${Number(datosSesiones.sesionesEspeciales.usuariosParticipantesEspecial || 0).toLocaleString("es-MX")} de ${Number(datosSesiones.sesionesEspeciales.usuariosBase || 0).toLocaleString("es-MX")} usuarios`}
                                                </small>
                                            </div>

                                            <div style={{ width: "120px", minHeight: "70px" }}>
                                                <ReactApexChart
                                                    options={especialEnVivoOptions}
                                                    series={especialEnVivoSeries}
                                                    type="area"
                                                    height={70}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-sm-6 col-lg-6 col-xl-3">
                                <div className="card">
                                    <div className="card-body iq-box-relative">
                                        <div
                                            className="iq-service d-flex align-items-center justify-content-between"
                                            style={{ position: "relative" }}
                                        >
                                            <div className="service-data">
                                                <h3 className="counter">
                                                    {loadingSesiones ? "..." : "0"}
                                                </h3>

                                                <p className="mb-0">
                                                    Sesiones Grabación
                                                </p>

                                                <small className="text-muted">
                                                    No hay registro de datos
                                                </small>
                                            </div>

                                            <div style={{ width: "120px", minHeight: "70px" }}>
                                                <ReactApexChart
                                                    options={especialGrabacionOptions}
                                                    series={especialGrabacionSeries}
                                                    type="area"
                                                    height={70}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-3">
                                <div className="card">
                                    <div className="card-header d-flex align-items-center justify-content-between">
                                        <div className="header-title">
                                            <h4 className="card-title">Top 3 sesiones En vivo</h4>
                                        </div>
                                    </div>

                                    <div className="card-body">
                                        <div className="iq-social-user-details">
                                            <div className="d-flex justify-content-center gap-3">
                                                <div className="img-fluid avatar-48 rounded-circle bg-primary-subtle d-flex align-items-center justify-content-center">
                                                    <span className="fw-bold">#</span>
                                                </div>

                                                <div className="d-flex align-items-center justify-content-between flex-grow-1">
                                                    <div className="me-3">
                                                        <h5></h5>
                                                        <small className="text-ellipsis short-1">
                                                            No hay datos disponibles.
                                                        </small>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* <p className="text-muted mb-0 mt-3">
                                            {datosSesiones.topSesionesEspeciales?.message ||
                                                "Pendiente por definir estructura de datos para top de sesiones especiales."}
                                        </p> */}
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-3">
                                <div className="card">
                                    <div className="card-header d-flex align-items-center justify-content-between">
                                        <div className="header-title">
                                            <h4 className="card-title">Top 3 sesiones Grabación</h4>
                                        </div>
                                    </div>

                                    <div className="card-body">
                                        <div className="iq-social-user-details">
                                            <div className="d-flex justify-content-center gap-3">
                                                <div className="img-fluid avatar-48 rounded-circle bg-secondary-subtle d-flex align-items-center justify-content-center">
                                                    <span className="fw-bold">#</span>
                                                </div>

                                                <div className="d-flex align-items-center justify-content-between flex-grow-1">
                                                    <div className="me-3">
                                                        <h5></h5>
                                                        <small className="text-ellipsis short-1">
                                                            No hay datos disponibles.
                                                        </small>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* <p className="text-muted mb-0 mt-3">
                                            Pendiente por integrar sesiones de grabación.
                                        </p> */}
                                    </div>
                                </div>
                            </div>
                        </div>

                        
                        <div className="row">
                            <div>
                                <h5>University of Panduit</h5>
                            </div>

                            <div className="col-lg-4">
                                <div className="card">
                                    <div className="card-header d-flex justify-content-between">
                                        <div className="header-title">
                                            <h4>Total Usuarios participantes</h4>
                                        </div>
                                    </div>

                                    <div className="card-body text-center">
                                        <ReactApexChart
                                            options={panduitUniversityChartOptions}
                                            series={panduitUniversityChartSeries}
                                            type="radialBar"
                                            height={350}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-4">
                                <div className="card">
                                    <div className="card-body">
                                        <div>Cursos terminados</div>

                                        <div className="d-flex align-items-center justify-content-between mt-3">
                                            <div>
                                                <h2 className="counter" style={{ visibility: "visible" }}>
                                                    {loadingSesiones
                                                        ? "..."
                                                        : Number(datosSesiones.panduitUniversity?.cursosTerminados || 0).toLocaleString("es-MX")}
                                                </h2>
                                                0%
                                            </div>

                                            <div className="border bg-info-subtle rounded p-3">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 10l7-7m0 0l7 7m-7-7v18"></path>
                                                </svg>
                                            </div>
                                        </div>

                                        <div className="mt-4">
                                            <div className="progress bg-info-subtle shadow-none w-100" style={{ height: "6px" }}>
                                                <div
                                                    className="progress-bar bg-info"
                                                    role="progressbar"
                                                    aria-valuenow="0"
                                                    aria-valuemin="0"
                                                    aria-valuemax="100"
                                                    style={{ width: "0%", transition: "width 2s" }}
                                                ></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="card">
                                    <div className="card-body">
                                        <div className="d-flex justify-content-between">
                                            <div>
                                                <span>Cursos completos</span>
                                                <div className="mt-2">
                                                    <h2 className="counter" style={{ visibility: "visible" }}>
                                                        {loadingSesiones
                                                            ? "..."
                                                            : Number(datosSesiones.panduitUniversity?.cursosCompletados || 0).toLocaleString("es-MX")}
                                                    </h2>
                                                </div>
                                            </div>

                                            {/* <div>
                                                <span className="badge bg-primary">Monthly</span>
                                            </div> */}
                                        </div>

                                        <div className="d-flex justify-content-between mt-2">
                                            <div>
                                                <span>0%</span>
                                            </div>
                                        </div>

                                        <div className="mt-3">
                                            <div className="progress bg-primary-subtle shadow-none w-100" style={{ height: "6px" }}>
                                                <div
                                                    className="progress-bar bg-primary"
                                                    role="progressbar"
                                                    aria-valuenow="0"
                                                    aria-valuemin="0"
                                                    aria-valuemax="100"
                                                    style={{ width: "0%", transition: "width 2s" }}
                                                ></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-4">
                                <div className="card">
                                    <div className="card-header">
                                        <div className="header-title">
                                            <h4 className="card-title">Top 5 Sesiones</h4>
                                        </div>
                                    </div>

                                    <div className="card-body">
                                        {!datosSesiones.panduitUniversity?.topCursos?.length ? (
                                            <div className="text-center py-5">
                                                <p className="mb-0 text-muted">
                                                    No hay datos disponibles
                                                </p>
                                            </div>
                                        ) : (
                                            <div className="mt-3">
                                                {datosSesiones.panduitUniversity.topCursos.map((curso, index) => (
                                                    <div className="pb-3" key={index}>
                                                        <div className="d-flex align-items-center justify-content-between mb-2">
                                                            <p className="mb-0">{curso.nombre}</p>
                                                            <h4>{curso.total}</h4>
                                                        </div>

                                                        <div className="progress bg-info-subtle shadow-none w-100" style={{ height: "10px" }}>
                                                            <div
                                                                className="progress-bar bg-info"
                                                                role="progressbar"
                                                                aria-valuenow={curso.porcentaje || 0}
                                                                aria-valuemin="0"
                                                                aria-valuemax="100"
                                                                style={{
                                                                    width: `${curso.porcentaje || 0}%`,
                                                                    transition: "width 2s",
                                                                }}
                                                            ></div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                )}

                {compareMode && (
                    <div className="row">
                        <div className="col-xl-6 mb-4">
                            <CompareSesionesPanel
                                filters={leftFilters}
                                regions={regions}
                                distys={leftDistys}
                                grados={leftGrados}
                                data={leftData}
                                loading={loadingLeftCompare}
                                onRegionChange={handleLeftRegionChange}
                                onDistyChange={handleLeftDistyChange}
                                onGradoChange={handleLeftGradoChange}
                            />
                        </div>

                        <div className="col-xl-6 mb-4">
                            <CompareSesionesPanel
                                filters={rightFilters}
                                regions={regions}
                                distys={rightDistys}
                                grados={rightGrados}
                                data={rightData}
                                loading={loadingRightCompare}
                                onRegionChange={handleRightRegionChange}
                                onDistyChange={handleRightDistyChange}
                                onGradoChange={handleRightGradoChange}
                            />
                        </div>
                    </div>
                )}
            </div>
        </main>
        </>
    )
}

export default SesionesSuperLider